import { render } from "./AdminSysPaymentTab.vue?vue&type=template&id=e85692a4&ts=true"
import script from "./AdminSysPaymentTab.vue?vue&type=script&lang=ts"
export * from "./AdminSysPaymentTab.vue?vue&type=script&lang=ts"

import "./AdminSysPaymentTab.vue?vue&type=style&index=0&id=e85692a4&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__